import React, { forwardRef } from 'react';

import useDebounce from '../../../../hooks/useDebounce';
import AutoCompleteClientes from './Template';

const Search = forwardRef(
  (
    {
      value,
      onChange,
      handleEnter = () => {},
      handleKey = () => {},
      resource,
      label,
      nested = [],
      toString = false,
      filters = {},
      campo = 'nome',
      campoPesquisa,
      autoFocus = false,
      perPage = 10,
      multiple = false,
      ...rest
    },
    forwardedRef,
  ) => {
    const [inputValue, setInputValue] = React.useState('');
    const [valueDebounce] = useDebounce(inputValue, 500);

    function keyPress(keyCode, keyName) {
      if (keyCode === 13) handleEnter();
      else handleKey(keyCode, keyName);
    }

    const parsedValue = toString
      ? value
        ? JSON.parse(value)
        : multiple
        ? []
        : null
      : value;

    return (
      <AutoCompleteClientes
        inputValue={inputValue}
        onChange={(newValue) => {
          if (toString) {
            onChange({
              target: {
                name: rest.name,
                value: JSON.stringify(newValue),
              },
            });
          } else {
            onChange(newValue);
          }
        }}
        updateValue={setInputValue}
        value={parsedValue}
        label={label}
        valueDebounce={valueDebounce}
        handleKey={keyPress}
        ref={forwardedRef}
        resource={resource}
        nested={nested}
        filters={filters}
        campo={campo}
        campoPesquisa={campoPesquisa}
        autoFocus={autoFocus}
        perPage={perPage}
        multiple={multiple}
        {...rest}
      />
    );
  },
);

export default Search;
